import React from 'react';
import { cx } from './cx';

export interface AdminSectionTitleProps {
  title: React.ReactNode;
  /** nút phụ dạng soft (Xuất CSV, Tải lại) hoặc ô chọn ngày bên phải */
  extra?: React.ReactNode;
  as?: 'h2' | 'h3';
  className?: string;
  id?: string;
}

// Tiêu đề khối 20px 700 bên trái + phần phụ bên phải.
export const AdminSectionTitle = ({ title, extra, as = 'h2', className, id }: AdminSectionTitleProps) => {
  const Tag = as;
  return (
    <div className={cx('adm-section-title', className)}>
      <Tag className="adm-section-title__title" id={id}>
        {title}
      </Tag>
      {extra && <div className="adm-section-title__extra">{extra}</div>}
    </div>
  );
};

export default AdminSectionTitle;
